module.exports = __webpack_public_path__ + "img/nerds-banner_mob.28736dbf.jpg";